export interface TierTransition {
  fromTier: string;
  toTier: string;
}

export enum CampaignStatus {
  ACTIVE = "ACTIVE",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  PAUSED = "PAUSED",
  CANCELLED = "CANCELLED",
}

export enum ExecutionMethod {
  SCHEDULED = "SCHEDULED",
  EVENT_DRIVEN = "EVENT_DRIVEN",
}

export enum EventType {
  BIRTHDAY = "BIRTHDAY",
  TIER_UPDATE = "TIER_UPDATE",
  EMAIL_OPTIN = "EMAIL_OPTIN",
  REGISTRATION = "REGISTRATION",
}

export enum CouponType {
  FREE = "FREE",
  PURCHASABLE = "PURCHASABLE",
}

export enum CouponValidityType {
  DEFAULT_FROM_CAMPAIGN = "DEFAULT_FROM_CAMPAIGN",
  DAYS_AFTER_PURCHASE = "DAYS_AFTER_PURCHASE",
  FIXED_END_DATE = "FIXED_END_DATE",
}

export enum TargetAudienceType {
  ALL_CUSTOMERS = "ALL_CUSTOMERS",
  SEGMENT = "SEGMENT",
  CIRCLES = "CIRCLES",
}

export interface CampaignApiResponse {
  campaignNumber: string;
  name: string;
  description?: string;
  type: "ONE_TIME" | "RECURRING";
  status?: string;
  startDate?: string;
  endDate?: string;
  executionMethod?: ExecutionMethod;
  scheduledDate?: string;
  executionTime?: string;
  eventType?: EventType | string;
  offsetDays?: number;
  executionHour?: string;
  birthdayDaysBefore?: number;
  birthdayTime?: string;
  tierUpdateTransitions?: TierTransition[];
  couponType?: CouponType | string;
  couponNumber?: string;
  couponTemplateNumber: string;
  couponName?: string;
  couponValidityType?: string;
  oneTimeValidityType?: "DAYS_AFTER_PURCHASE" | "FIXED_EXPIRY_DATE";
  validityDays?: number;
  fixedEndDate?: string;
  fixedExpiryDate?: string;
  targetAudienceType?: TargetAudienceType | string;
  audienceType?: string;
  targets?: string[];
  segmentNumbers?: string[];
  segmentName?: string;
  circleNumbers?: string[];
  circleNames?: string[];
  notificationPlan?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CampaignFormDto {
  name: string;
  description?: string;
  executionMethod: ExecutionMethod;
  scheduledDate?: string;
  eventType?: EventType;
  birthdayDaysBefore?: number;
  birthdayTime?: string;
  tierUpdateTransitions?: TierTransition[];
  couponType: CouponType;
  couponNumber: string;
  startDate?: string;
  endDate?: string;
  couponValidityType: CouponValidityType;
  validityDays?: number;
  fixedEndDate?: string;
  targetAudienceType: TargetAudienceType;
  segmentNumbers?: string[];
  circleNumbers?: string[];
  notificationPlan?: string;
}

export interface CreateCampaignRequest {
  name: string;
  description?: string;
  type: "ONE_TIME" | "RECURRING";
  couponTemplateNumber: string;
  audienceType: "ALL" | "SEGMENT" | "CIRCLE";
  executionTime?: string;
  eventType?: "BIRTHDAY" | "CIRCLE_UPGRADE" | "EMAIL_OPT_IN" | "REGISTRATION";
  offsetDays?: number;
  executionHour?: string;
  startDate?: string;
  endDate?: string;
  notificationPlan?: string;
  targets?: string[];
  reminders?: CampaignReminderRequest[];
  validityDays?: number;
  oneTimeValidityType?: "DAYS_AFTER_PURCHASE" | "FIXED_EXPIRY_DATE";
  fixedExpiryDate?: string;
}

export interface CampaignReminderRequest {
  offsetDays: number;
  executionHour: string;
  channel: string;
}
